import { useFormContext } from 'react-hook-form'

import { useClientePorCpfProposta } from '@/features/clientes/hooks/use-cliente-por-cpf-proposta'
import { BaseRepresentanteLegalForm } from '@/features/proposta/components/ui'
import { useDadosRepresentanteLegalVinculo } from '@/features/proposta/hooks/use-dados-representante-legal-vinculo'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'
import type { CompradorVinculoStepSchemaInput } from '@/features/proposta/schemas/compradores/comprador-pf.schema'
import type { TNacionalidade, TProfissao } from '@/shared/interfaces/cliente.types'

type TDadosCompradorVinculo = {
  onBack: () => void
  onNext: () => void
  compradores: TCompradoresCadastrados
  nacionalidades: TNacionalidade[]
  profissoes: TProfissao[]
}

export const DadosRepresentanteLegalVinculo = ({
  onNext,
  onBack,
  compradores,
  nacionalidades,
  profissoes,
}: TDadosCompradorVinculo) => {
  const {
    formState: { errors },
    watch,
    control,
  } = useFormContext<CompradorVinculoStepSchemaInput>()

  const cpf = watch('dados.cpf')
  const buscouCpf = !!watch('dados.buscouCpf')
  const cpfRaw = cpf?.replace(/\D/g, '')
  const cpfError = errors?.dados?.cpf
  const isEditing = watch('mode') === 'edit'

  const { refetch, isFetching } = useClientePorCpfProposta(String(cpfRaw), false)
  const { handlers } = useDadosRepresentanteLegalVinculo({
    onNext,
    compradores,
    refetch,
    nacionalidadePrincipalId: nacionalidades[0]?.id ?? '',
  })

  return (
    <BaseRepresentanteLegalForm
      onBack={onBack}
      onNext={onNext}
      compradores={compradores}
      nacionalidades={nacionalidades}
      profissoes={profissoes}
      control={control}
      fields={{
        cpf: 'dados.cpf',
        nome: 'dados.nome',
        nacionalidadeId: 'dados.nacionalidadeId',
        profissaoId: 'dados.profissaoId',
      }}
      isEditing={isEditing}
      cpf={cpf}
      buscouCpf={buscouCpf}
      cpfError={cpfError}
      isFetching={isFetching}
      handlers={handlers}
    />
  )
}
